import classNames from 'classnames';

import { ClassNameType } from 'interfaces';

const styles = {
  component: (
    className: ClassNameType,
  ) => className,
  toggleSection: classNames(
    'sm:flex',
    'justify-between',
    'content-center',
    '!mt-7',
  ),
  toggleButton1: classNames(
    '!mr-2',
    'capitalize',
    'text-base',
  ),
  toggleButton2: classNames(
    'capitalize',
    'text-base',
  ),
  toggle: classNames(
    '!mt-0',
    '!mb-6',
    'sm:!my-5',
    'sm:flex',
    'justify-between',
  ),
  grayContainerClasses: classNames(
    'relative',
    '!p-0',
    'md:!p-0',
    'overflow-hidden',
    'h-[350px]',
    'md:h-[720px]',
    'lg:min-h-[720px]',
  ),
  toggleButtonMobileContainer: classNames(
    'bg-lightGray',
    'h-[65px]',
    'translate-y-1',
    'rounded-tl-2xl',
    'rounded-tr-2xl',
    'relative',
    '!mt-8',
    'lg:!mt-0',
    'flex',
    'justify-center',
  ),
  toggleButton: classNames(
    'bg-secondaryBlue',
    'absolute',
    'top-0',
    '!p-4',
    'flex',
    'text-white',
    'font-bold',
    'rounded-bl-xl',
    'rounded-br-xl',
    'hover:bg-secondaryBlue-600',
  ),
  viewToggleButton: classNames(
    'z-10',
    'bg-secondaryBlue',
    'absolute',
    'top-0',
    '!p-4',
    'flex',
    'text-white',
    'font-bold',
    'rounded-bl-xl',
    'rounded-br-xl',
    'hover:bg-secondaryBlue-600',
  ),
};

export default styles;
